import { ShoppingBag, ExternalLink } from "lucide-react";
import useApi, { LoadError } from "@/lib/useApi";
import useSEO from "@/hooks/useSEO";
import { PageHero, Reveal, Empty } from "@/components/ui-lux";

const STOREFRONT = "https://a.co/d/0ghVws8W";
const ext = { target: "_blank", rel: "noopener noreferrer sponsored" };

const ProductCard = ({ p }) => (
  <a href={p.amazon_url} {...ext} className="card-lux overflow-hidden flex flex-col group" data-testid={`product-card-${p.slug}`}>
    <div className="aspect-[4/5] bg-white/5 overflow-hidden">
      {p.image ? <img src={p.image} alt={p.title} className={`w-full h-full transition-transform duration-500 group-hover:scale-105 ${p.image.includes("/store/") ? "object-contain p-6" : "object-cover object-top"}`} /> : <div className="w-full h-full flex items-center justify-center text-gold-light/60"><ShoppingBag size={48} /></div>}
    </div>
    <div className="p-6 flex flex-col flex-1">
      {p.category && <p className="text-xs uppercase tracking-widest text-gold-light font-accent">{p.category}</p>}
      <h3 className="font-serif text-lg font-semibold text-white mt-1">{p.title}</h3>
      <p className="text-sm text-slate-400 mt-2 line-clamp-3">{p.description}</p>
      <div className="flex-1" />
      <span className="btn-gold !py-2.5 mt-5" data-testid={`product-buy-${p.slug}`}><ShoppingBag size={14} />Buy on Amazon</span>
    </div>
  </a>
);

export default function Store() {
  const { data: items, error, reload } = useApi("/content/products", []);
  useSEO({ title: "Store", description: "Books, resources and favorite picks recommended by Todd Coconato." });
  return (
    <div data-testid="store-page">
      <PageHero eyebrow="Store" title="Todd's recommended picks." sub="Books, Bibles and tools that help you renew your mind and grow in your walk with God." image="/images/todd-stadium.jpg" />
      <div className="container-x">
        <Reveal>
          <div className="card-lux p-8 sm:p-10 flex flex-col md:flex-row md:items-center justify-between gap-6 mb-14" data-testid="storefront-banner">
            <div>
              <span className="eyebrow">Amazon Storefront</span>
              <h2 className="font-serif text-2xl sm:text-3xl text-white">See everything Todd recommends</h2>
            </div>
            <a href={STOREFRONT} {...ext} className="btn-gold shrink-0" data-testid="storefront-link">Visit the storefront <ExternalLink size={15} /></a>
          </div>
        </Reveal>
        {error ? <LoadError onRetry={reload} /> : items && !items.length ? <Empty text="Products are coming soon." /> : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {(items || []).map((p) => <ProductCard key={p.id} p={p} />)}
          </div>
        )}
        <p className="text-xs text-slate-500 mt-12 text-center" data-testid="amazon-disclosure">As an Amazon Associate I earn from qualifying purchases.</p>
      </div>
    </div>
  );
}
